import axios from './axios'

export async function getGeoLocation(params: String) {
    try{
        const response = await axios.get('/api/location/' + params);
        console.log('/api/location/' + params);
        return response.data.addresses;
    } catch (e) {
        console.log('')
    }
}

